var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsMessage = function SvgSmsMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.834.667H3.167A2.833 2.833 0 0 0 .334 3.5v17a2.833 2.833 0 0 0 2.833 2.834h22.667a2.834 2.834 0 0 0 2.833-2.834v-17A2.833 2.833 0 0 0 25.834.667Zm0 6.658-11.333 7.557L3.167 7.325V3.921l11.334 7.555 11.333-7.555v3.404Z",
    fill: "#8E6F00"
  })));
};
export default SvgSmsMessage;